import { gql } from 'apollo-angular';

export const GET_USER = gql`
  query GetUser($userId: ID!) {
    student(user_id: $userId) {
      metadata {
        selectedTutorSkin
        selectedTutorRig
      }
    }
  }
`;

export default {
  GET_USER,
};
